import React from 'react';
import {
  addAddress,
  changeEmail,
  changePassword,
  confirm,
  getAccount,
  login,
  logout,
  recheckSolvency,
  register,
  removeAddress,
  requestConfirmationEmail,
  requestPasswordReset,
  resetPassword,
  setDefaultBillingAddress,
  setDefaultShippingAddress,
  update,
  updateAccountWithWebservice,
  updateAddress,
} from '../../actions/account';
import {
  addItem,
  cartItems,
  checkout,
  fetchCart,
  getAvailableShippingMethods,
  getProjectSettings,
  getShippingMethods,
  orderHistory,
  redeemDiscountCode,
  removeDiscountCode,
  removeItem,
  setShippingMethod,
  undoRefuseGift,
  updateCart,
  updateItem,
} from '../../actions/cart';
import { addToWishlist, getWishlist, removeLineItem, updateLineItem } from '../../actions/wishlist';
import { createSession } from '../../actions/adyen';
import { UseAccount } from './UseAccount';
import { UseCart } from './UseCart';
import { UseWishlist } from './UseWishlist';
import { UseAdyen } from './UseAdyen';
import {
  EcondaWidgetConfiguration,
  PageFolderTree,
  ProjectInfo,
  TBreadcrumb,
} from '@frontastic-engbers/types/engbers-custom';
import { Outfit } from '@frontastic-engbers/types/product/Outfit';

export interface FrontasticState {
  useCart: UseCart;
  useAccount: UseAccount;
  useWishlist: UseWishlist;
  useAdyen: UseAdyen;
  projectInfo: ProjectInfo;
  structuredBreadcrumb: TBreadcrumb[];
  setStructuredBreadcrumb: React.Dispatch<React.SetStateAction<TBreadcrumb[]>>;
  shop: string;
  categoryTree?: PageFolderTree;
}

export interface GlobalState {
  isFlyoutCartOpen: boolean;
  flyoutAlternativeProductsConfig?: (EcondaWidgetConfiguration & { sku?: string; categoryUrl?: string }) & Outfit;
}

export const getFrontasticState = (
  type?: 'pwa' | 'shop',
): Omit<
  FrontasticState,
  'structuredBreadcrumb' | 'setStructuredBreadcrumb' | 'shop' | 'categoryTree'
> => {
  return {
    useCart: {
      ...(type !== 'pwa' && cartItems()),
      addItem,
      updateCart,
      removeItem,
      updateItem,
      getShippingMethods,
      getAvailableShippingMethods,
      setShippingMethod,
      checkout,
      fetchCart,
      orderHistory,
      getProjectSettings,
      redeemDiscountCode,
      removeDiscountCode,
      undoRefuseGift,
    },
    useAccount: {
      ...getAccount(),
      login,
      logout,
      register,
      confirm,
      requestConfirmationEmail,
      changePassword,
      requestPasswordReset,
      resetPassword,
      update,
      addAddress,
      updateAddress,
      removeAddress,
      changeEmail,
      recheckSolvency,
      setDefaultBillingAddress,
      setDefaultShippingAddress,
      updateAccountWithWebservice,
    },
    useWishlist: {
      ...getWishlist(),
      addToWishlist,
      removeLineItem,
      updateLineItem,
    },
    useAdyen: {
      createSession,
    },
    projectInfo: {
      name: '',
      projectId: '',
      siteUrl: '',
      env: '',
    },
  };
};
